import { render, staticRenderFns } from "./p27.vue?vue&type=template&id=6dd262e3&scoped=true&"
import script from "./p27.vue?vue&type=script&lang=js&"
export * from "./p27.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd262e3",
  null
  
)

export default component.exports